import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { useTranslation } from 'react-i18next';

const QuickTipsCard: React.FC = () => {
  const { t } = useTranslation('dashboard');
  
  return (
    <Card sx={{ 
      height: '100%',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      transition: 'all 0.2s ease',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      },
    }}>
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
            {t('tips.title')}
          </Typography>
        </Box>
        
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
              💡 {t('tips.createProfiles')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t('tips.createProfilesDesc')}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
              🎯 {t('tips.specificPurposes')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t('tips.specificPurposesDesc')}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
              📊 {t('tips.reviewHistory')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t('tips.reviewHistoryDesc')}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 0.5 }}>
              ✨ {t('tips.customizeTone')}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {t('tips.customizeToneDesc')}
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickTipsCard;
